import {
    ApolloClient,
    ApolloQueryResult,
    NetworkStatus,
    NormalizedCacheObject,
    QueryOptions,
} from '@apollo/client';
import Bugsnag from '@bugsnag/js';

/**
 * Executes GraphQL query and handles any thrown errors avoiding app crashing
 *
 * @param {ApolloClient<NormalizedCacheObject>} client Initialised Apollo client
 * @param {QueryOptions} queryOptions Query options
 * @param {string | undefined} context Optional context for an error
 * @returns {Promise<ApolloQueryResult<Q>>}
 */
export async function handleQuery<Q>(
    client: ApolloClient<NormalizedCacheObject>,
    queryOptions: QueryOptions,
    context?: string
): Promise<ApolloQueryResult<Q>> {
    try {
        const response = await client.query(queryOptions);
        if (response.error) {
            if (context) {
                Bugsnag.notify(response.error, (event) => {
                    event.context = context;
                });
            } else {
                Bugsnag.notify(response.error);
            }
        }

        return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.networkError) {
            Bugsnag.notify(error, (event) => {
                event.context = error.networkError?.bodyText;
            });
        } else {
            Bugsnag.notify(error);
        }

        return {
            error,
            data: null as unknown as Q,
            loading: false,
            networkStatus: NetworkStatus.error,
        };
    }
}
